export const PURCHASE_MANAGEMENT_RIGHT_MENU = {
    SET_INITIAL_DATE:'PURCHASE_MANAGEMENT_RIGHT_MENU.SET_INITIAL_DATE',
    SET_FINAL_DATE:'PURCHASE_MANAGEMENT_RIGHT_MENU.SET_FINAL_DATE',
    SET_STATE_SITUATIONS:'PURCHASE_MANAGEMENT_RIGHT_MENU.SET_STATE_SITUATIONS',
    SET_STATE_TYPE:'PURCHASE_MANAGEMENT_RIGHT_MENU.SET_STATE_TYPE',
    SET_STATE_PROVIDER_ID:'PURCHASE_MANAGEMENT_RIGHT_MENU.SET_STATE_PROVIDER_ID',
}